<template>
  <kst-page-print pageFooter
    v-slot="{ title }"
    :catalog="TrxSearchCatalog"
    :params="Model.UrlParams"
    :search="searchData"
    @init="handleInit"
  >
    <div class="columns is-mobile">
      <div class="column is-half">
        <Company :data="companyData"/>
      </div>
      <div class="column is-half">
        <div class="is-size-3">{{ title }}</div>
      </div>
    </div>

    <List class="block" :dataList="dataList" :access="access"/>
  </kst-page-print>
</template>

<script>
import Model from "../TrxModel.js";
import TrxSearchCatalog from "../TrxSearchCatalog.js";
import Services from "../../../services/Api/TransactionServices.js";

import List from "./TrxP_List.vue";
import Company from "../../Company/RelatedPrintDetails/CpRPD.vue";

export default {
  components: {
    List,
    Company
  },
  data: () => ({
    Model: Model,
    TrxSearchCatalog: TrxSearchCatalog,
    access: {},
    companyData: {},
    dataList: [],
    searchData: {
      Date: null,
      ItemID: null,
      WarehouseID: null,
      TransactionTypeID: null,
      // support
      ItemName: null
    }
  }),
  created() {
    this.resetSearch();
  },
  methods: {
    /*** by page ***/

    handleInit(loadPrint) {
      this.resetData();

      const options = this.getListOptions();
      const config = Services.getPrintData(options);
      loadPrint(config, this.handleInit_success);
    },
    handleInit_success(data) {
      this.companyData = data.CompanyDetails;
      this.dataList = data.List;
    },

    /*** custom ***/

    resetData() {
      this.access = this.$kst.Access.create(Model.Access);
      this.companyData = {};
      this.dataList = [];
    },
    
    resetSearch() {
      this.searchData.Date = this.$kst.In.getDefaultDateRange();
      this.searchData.ItemID = null;
      this.searchData.WarehouseID = this.$kst.Session.getDefaultWarehouseID();
      this.searchData.TransactionTypeID = this.$kst.Search.OptionAll;
      // support
      this.searchData.ItemName = null;
    },

    getListOptions() {
      return {
        item: this.$kst.Out.getInteger(this.searchData.ItemID),
        warehouse: this.$kst.Search.getValue(this.searchData.WarehouseID),
        transactiontype: this.$kst.Search.getValue(
          this.searchData.TransactionTypeID),
        startdate: this.$kst.Out.getDateString(this.searchData.Date[0]),
        enddate: this.$kst.Out.getDateString(this.searchData.Date[1])
      };
    }
  }
}
</script>